import { createApp } from 'vue';
import {
  useTheme,
  fareharborLightTheme,
} from '@fareharbor-com/beacon-vue/themes';
import '@fareharbor-com/beacon-vue/fonts/roboto';

import {
  prepareInterpolateFunction,
  mockTranslationFunctions,
} from './scripts/prepareTranslationScripts';
import './styles.scss';

import App from './App.vue';

const app = createApp(App);

const renderApp = (isTranslationsLoadFailed) => {
  if (isTranslationsLoadFailed) {
    mockTranslationFunctions();
  }

  prepareInterpolateFunction(window.interpolate);

  app.mixin({
    methods: {
      T: window.T,
      nT: window.nT,
      cT: window.cT,
      interpolate: window.interpolate,
    },
  });

  app.mount('#app');

  // Use the standard dashboard theme from Beacon
  useTheme(fareharborLightTheme);
};

if (window.loadTranslationsStatus.isLoaded) {
  renderApp(window.loadTranslationsStatus.isFailed);
  delete window.loadTranslationsStatus;
} else {
  const listenerFunction = () => {
    renderApp(window.loadTranslationsStatus.isFailed);

    document.removeEventListener(
      window.loadTranslationsStatus.eventName,
      listenerFunction,
    );

    delete window.loadTranslationsStatus;
  };

  document.addEventListener(
    window.loadTranslationsStatus.eventName,
    listenerFunction,
  );
}
